import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../../../common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { OutOfPlaceRestore } from './out-of-place-restore.component';
import { VmDestinationFolderTree } from './step-1/step-1.component';
import { VmComputeResourceTree } from './step-2/step-2.component';
import { VmStorageList } from './step-3/step-3.component';

@NgModule({
    imports: [
        CommonModule,
        ClarityModule.forRoot(),
        FormsModule,
        VcaCommonModule,
        TranslateModule
    ],
    declarations: [
        OutOfPlaceRestore,
        VmDestinationFolderTree,
        VmComputeResourceTree,
        VmStorageList
    ],
    exports: [
        OutOfPlaceRestore,
        VmDestinationFolderTree,
        VmComputeResourceTree,
        VmStorageList
    ]
})
export  class OutOfPlaceRestoreModule {
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/out-of-place-restore/out-of-place-restore.module.ts